import Carousel from './carousel';

const carouselConfig = {
  name: 'carousel',
  class: Carousel,
  querySelectorAll: {
    slider: '.block-carousel__list',
    gallery: '.blocks-gallery-grid',
  },
  options: {
    slickOptions: {
      dots: true,
      infinite: false,
      slidesToShow: 3,
      slidesToScroll: 1,
      focusOnSelect: true,
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 3,
            slidesToScroll: 3,
            infinite: true,
            dots: true,
          },
        },
        {
          breakpoint: 768,
          settings: {
            slidesToShow: 2,
            slidesToScroll: 2,
          },
        },
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
            slidesToScroll: 1,
          },
        },
      ],
    },
  },
};

export default carouselConfig;
